import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, white} from '/theme/color/on.color';
import {alto, pine, violet} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  headerText: {
    fontSize: 16,
  },
  content: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: indent,
    marginTop: indent * 6,
  },
  icon: {
    fontSize: 50,
    textAlign: 'center',
    color: violet,
  },
  modalFooter: {
    flexDirection: 'column',
  },
  textStyle: {
    color: black,
    fontWeight: 'bold',
  },
  enableText: {
    fontSize: 16,
    padding: indent,
    textAlign: 'center',
  },
  turnonText: {
    fontSize: 14,
    marginHorizontal: indent * 3,
    width: '60%',
    paddingBottom: indent * 2,
    textAlign: 'center',
  },
  enableButton: {
    backgroundColor: pine,
    width: '90%',
    marginLeft: indent,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 40,
  },
  buttonBox: {
    borderWidth: 1,
    borderColor: alto,
    width: '90%',
    marginLeft: indent,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 40,
  },
});
